<div class="inner-header">
  <div class="header-left" [class.hidden]="!showDismissButton && !hasHeaderLeftContent">
    @if (showDismissButton) {
      <!-- [attr.icon] is deliberate alongside [icon]. Every other icon button in the app
           names its icon as a plain attribute, and E2E specs select on that
           (cs-icon-button[icon="ellipsis-vertical"] and friends). A property binding alone
           sets the input but leaves NO attribute in the DOM, so that selector shape would
           quietly stop matching here only. cs-icon-button does not reflect the input, so
           the attribute has to be written explicitly. -->
      <cs-icon-button [icon]="dismissIcon" [attr.icon]="dismissIcon" large id="backButton"
      (click)="handleBackButtonClick($event)"></cs-icon-button>
    }
    <ng-content select="[header-left]"></ng-content>
  </div>
  <ng-content select="cs-header-title"></ng-content>
  @if (isOffline) {
    <cs-badge class="offline-badge" icon="cloud-offline" [label]="LL.common.offlineBadge()" [color]="BadgeColor.Yellow"></cs-badge>
  }
  <div class="header-right" [class.hidden]="!hasHeaderRightContent">
    <ng-content select="[header-right]"></ng-content>
  </div>
  @if (showConnectionStatus) {
    <cs-header-progress></cs-header-progress>
  }
</div>
@if (separator) {
  <div class="header-separator"></div>
}
<ng-content select="cs-header-content"></ng-content>
<ng-content></ng-content>